"use client";

import { Moon, Sun, Mouse, LaptopMinimal } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useTouchOptimized } from "@/hooks/use-touch-optimized";

export function UIModeToggle() {
  const { isTouchOptimized, toggleTouchOptimized } = useTouchOptimized();
  const { setTheme } = useTheme();

  return (
    <div className="flex gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon">
            <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">Toggle theme</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setTheme("light")}>
            Light
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setTheme("dark")}>
            Dark
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setTheme("system")}>
            System
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Button
        variant="outline"
        size="icon"
        onClick={toggleTouchOptimized}
        className={isTouchOptimized ? "bg-primary text-primary-foreground" : ""}
      >
        {isTouchOptimized ? (
          <LaptopMinimal className="h-[1.2rem] w-[1.2rem]" />
        ) : (
          <Mouse className="h-[1.2rem] w-[1.2rem]" />
        )}
        <span className="sr-only">Toggle touch optimization</span>
      </Button>
    </div>
  );
}
